

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import NotFound from './NotFound';
import About from './page/about/About';
import Blog from './page/blog/Blog';
import Contact from './page/contact/Contact';
import Resume from './page/Resume/Resume';
import Work from './page/work/Work';
function App() {
  return (
    <Router>
      <Routes>
        <Route index element={<About />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/work" element={<Work />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
